import { render, staticRenderFns } from "./AdminArticlesList.vue?vue&type=template&id=44478957"
import script from "./AdminArticlesList.vue?vue&type=script&lang=js"
export * from "./AdminArticlesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports